





























































































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { Inject } from '@cds/common';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import { massSet } from '@/services/massage-service';
import { ElForm } from 'element-ui/types/form';

@Component({
  components: {}
})
export default class ModulePermissionPopup extends Vue {
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;
  @Inject(massSet) private massSet!: massSet;

  @Emit('saved')
  private async emitSaved(): Promise<void> {
  }

  @Emit('cancel')
  private async emitClose(): Promise<void> {
  }

  @Prop() private permissionId!: Number;

  @Watch('permissionId', { immediate: true, deep: true })
  public async onChangePermissionId(newVal: any, oldVal: any) {
    console.log('permissionId watch', newVal)
    const isEdit = typeof newVal === 'number';
    this.isEdit = isEdit;
    
    // 先获取初始化数据，确保选项数据先加载完成
    await this.fetchInitialData();
    
    if (isEdit) {
      await this.fetchPermissionDetail();
    } else {
      this.resetFormData();
    }
  }

  public isEdit: Boolean = false;

  // 表单数据
  public formData: any = {
    id: null,
    modelCode: '',
    appCovers: [],
    openRange: [],
    userGroups: [],
    emails: [],
    emailsStr: ''
  };

  // 模块选项
  public moduleOptions: any[] = [
    { value: 'application', label: '应用' },
    { value: 'scenarios', label: '业务场景' },
    { value: 'novartis_video', label: '诺华视界' }
  ];

  // 封面选项
  public coverOptions: any[] = [];

  // 用户范围选项
  public buOptions: any[] = [];

  // 用户组选项
  public userGroupOptions: any[] = [];

  // 表单校验规则
  public rules: any = {
    modelCode: [{ required: true, message: '请选择所属模块', trigger: 'change' }],
    appCovers: [{ required: true, message: '请选择封面', trigger: 'change' }],
    openRange: [
      {
        validator: (rule: any, value: any, callback: Function) => {
          // 不再依赖 this.formData，而是通过实际验证时的状态来判断
          const form = (this.$refs.permissionForm as any).model;
          console.log('验证器执行 - form:', form);
          console.log('验证器执行 - form.userGroups:', form.userGroups);
          console.log('验证器执行 - form.emailsStr:', form.emailsStr);
          
          const hasOpenRange = value && Array.isArray(value) && value.length > 0;
          const hasUserGroups = form.userGroups && Array.isArray(form.userGroups) && form.userGroups.length > 0;
          const hasEmails = form.emailsStr && form.emailsStr.trim() !== '';
          
          console.log('验证结果 - hasOpenRange:', hasOpenRange);
          console.log('验证结果 - hasUserGroups:', hasUserGroups);
          console.log('验证结果 - hasEmails:', hasEmails);
          
          if (!hasOpenRange && !hasUserGroups && !hasEmails) {
            console.log('验证失败：三个字段都为空');
            callback(new Error('用户范围、用户组和用户邮箱必须至少填写一项'));
          } else {
            console.log('验证通过');
            callback();
          }
        },
        trigger: ['change', 'blur']
      }
    ]
  };

  // 用户检测相关
  public totalNum: number = 0;
  public noNum: number = 0;
  public useNum: number = 0;
  public noNumshow: Boolean = false;
  public subShow: Boolean = true;

  // 计算过滤后的封面选项
  get filteredCoverOptions() {
    return this.coverOptions.filter(item => item.modelCode === this.formData.modelCode);
  }

  public async created(): Promise<void> {
  }

  // 获取初始化数据
  private async fetchInitialData(): Promise<void> {
    await Promise.all([
      this.fetchUserGroups(),
      this.fetchCoverOptions()
    ]);
  }

  // 获取用户范围和用户组
  private async fetchUserGroups(): Promise<void> {
    try {
      // 获取BU列表
      const buRes = await this.nuoxiaoerService.getBUList();
      // 获取用户组列表
      const userGroupRes = await this.nuoxiaoerService.fetchUserGroupList({});

      if (buRes && Array.isArray(buRes)) {
        this.buOptions = buRes;
      } else {
        this.buOptions = [];
      }

      if (userGroupRes && Array.isArray(userGroupRes)) {
        this.userGroupOptions = userGroupRes.map((group: any) => ({
          id: group.groupId,
          name: group.groupName,
          type: group.groupType
        }));
      } else {
        this.userGroupOptions = [];
      }
    } catch (error) {
      console.error('获取用户范围和用户组失败：', error);
      this.$message.error('获取用户范围和用户组失败，请刷新重试');
      this.buOptions = [];
      this.userGroupOptions = [];
    }
  }

  // 获取封面选项
  private async fetchCoverOptions(): Promise<void> {
    try {
      const res = await this.nuoxiaoerService.fetchAppCoverOption();
      if (res && Array.isArray(res)) {
        this.coverOptions = res.map((item: any) => ({
          id: item.id,
          name: item.name,
          modelCode: item.modelCode,
          remarks: item.remarks || ''
        }));
      } else {
        this.coverOptions = [];
      }
    } catch (error) {
      console.error('获取封面选项失败：', error);
      this.$message.error('获取封面选项失败，请刷新重试');
      this.coverOptions = [];
    }
  }

  // 获取权限详情
  private async fetchPermissionDetail(): Promise<void> {
    try {
      const res = await this.nuoxiaoerService.fetchPermissionDetail({ id: this.permissionId });

      if (res) {
        // 先处理封面选项，将详情返回的已选中封面选项合并到coverOptions中
        // if (res.appCovers && Array.isArray(res.appCovers)) {
          // const existingCoverIds = this.coverOptions.map(item => item.id);
          
          // res.appCovers.forEach((cover: any) => {
            // 如果当前coverOptions中不存在这个封面选项，则添加进去
            // if (!existingCoverIds.includes(cover.id)) {
              // this.coverOptions.push({
              //   id: cover.id,
              //   name: cover.name,
              //   modelCode: cover.modelCode,
              //   remarks: cover.remarks || ''
              // });
            // }
          // });
        // }
        console.log('this.coverOptions',this.coverOptions)
        // 处理用户组选项，将详情返回的已选中用户组选项合并到userGroupOptions中
        if (res.userGroups && Array.isArray(res.userGroups)) {
          const existingGroupIds = this.userGroupOptions.map(item => item.id);
          
          res.userGroups.forEach((group: any) => {
            // 如果当前userGroupOptions中不存在这个用户组选项，则添加进去
            if (!existingGroupIds.includes(group.groupId)) {
              this.userGroupOptions.push({
                id: group.groupId,
                name: group.groupName || `用户组${group.groupId}`,
                type: group.groupType || ''
              });
            }
          });
        }

        // 最后设置表单数据，此时选项数据已经完整
        this.formData = {
          id: res.id,
          modelCode: res.modelCode || '',
          appCovers: res.appCovers ? res.appCovers.map((cover: any) => cover.id) : [],
          openRange: res.openScope || [],
          userGroups: res.userGroups ? res.userGroups.map((group: any) => group.groupId) : [],
          emails: res.emails || [],
          emailsStr: (res.emails || []).join(',')
        };

        // 处理邮箱字符串
        this.handleEmailsInput();
      }
    } catch (error) {
      console.error('获取权限详情失败：', error);
      this.$message.error('获取权限详情失败，请刷新重试');
    }
  }

  // 重置表单数据
  private resetFormData(): void {
    this.formData = {
      id: null,
      modelCode: '',
      appCovers: [],
      openRange: [],
      userGroups: [],
      emails: [],
      emailsStr: ''
    };

    // 重置用户检测状态
    this.totalNum = 0;
    this.noNum = 0;
    this.useNum = 0;
    this.noNumshow = false;
    this.subShow = true;

    // 清除表单验证状态
    this.$nextTick(() => {
      if (this.$refs.permissionForm) {
        (this.$refs.permissionForm as ElForm).clearValidate();
        // 强制重置表单
        (this.$refs.permissionForm as ElForm).resetFields();
      }
    });
  }

  // 模块变更处理
  public handleModuleChange(): void {
    // 清空封面选择
    this.formData.appCovers = [];
    
    // 触发表单验证
    this.$nextTick(() => {
      (this.$refs.permissionForm as ElForm).validateField(['appCovers']);
    });
  }

  // 用户范围变更处理
  public handleUserScopeChange(): void {
    // 触发openRange字段验证，这会清除所有相关字段的错误状态
    this.$nextTick(() => {
      (this.$refs.permissionForm as ElForm).validateField(['openRange']);
    });
  }

  // 用户组变更处理
  public handleUserGroupsChange(): void {
    console.log('用户组变更:', this.formData.userGroups);
    // 延迟较长时间确保数据完全更新后再验证
    setTimeout(() => {
      console.log('延迟验证时的用户组:', this.formData.userGroups);
      (this.$refs.permissionForm as ElForm).clearValidate(['openRange']);
      (this.$refs.permissionForm as ElForm).validateField(['openRange']);
    }, 300);
  }

  // 处理邮箱输入
  public handleEmailsInput(): void {
    this.noNumshow = false;
    
    if (!this.formData.emailsStr || this.formData.emailsStr.trim() === '') {
      this.totalNum = 0;
    } else {
      // 不在输入时立即格式化，只统计邮箱数量
      // 统计时支持中文逗号和英文逗号分隔
      const strLength = this.formData.emailsStr.split(/[,，]/);
      const validEmails = strLength.map(email => email.trim()).filter(email => email);
      this.totalNum = validEmails.length;
    }
    
    if (this.totalNum > 0) {
      this.subShow = false;
    } else {
      this.subShow = true;
    }

    // 触发openRange字段验证，这会清除所有相关字段的错误状态
    this.$nextTick(() => {
      (this.$refs.permissionForm as ElForm).validateField(['openRange']);
    });
  }

  // 处理邮箱输入时的按键事件
  public handleEmailKeydown(event: KeyboardEvent): void {
    // 阻止回车键换行
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  // 格式化邮箱字符串（在检测用户或提交时调用）
  private formatEmailString(): string {
    if (!this.formData.emailsStr || this.formData.emailsStr.trim() === '') {
      return '';
    }
    
    // 支持中文逗号和英文逗号分隔，在处理时统一转换为英文逗号
    const strLength = this.formData.emailsStr.split(/[,，]/);
    const validEmails = Array.from(new Set(strLength.map(email => email.trim()).filter(email => email)));
    return validEmails.join(',');
  }

  // 检测用户
  public async checkPerson(): Promise<void> {
    if (!this.formData.emailsStr || this.formData.emailsStr.trim() === '') {
      this.$message.error('请先输入用户邮箱');
      return;
    }

    try {
      const data = {
        usersStr: this.formatEmailString()
      };
      
      const res: any = await this.massSet.persnSearch(data);
      
      if (res) {
        this.noNum = res.unFinds.length;
        this.useNum = res.empIds.length + res.emails.length;
        this.totalNum = res.unFinds.length + res.empIds.length + res.emails.length;
        this.noNumshow = true;
        this.formData.emailsStr = res.usersStr;
        
        if (res.unFinds.length > 0) {
          this.subShow = false;
          this.$alert('用户：' + res.unFinds.toString() + ' 不存在', '错误用户', {
            confirmButtonText: '确定',
            callback: () => {}
          });
        } else {
          this.$message({
            type: 'success',
            message: '用户检测完成'
          });
          this.subShow = true;
        }
      }
    } catch (error) {
      console.error('检测用户失败：', error);
      this.$message.error('检测用户失败，请重试');
    }
  }

  // 提交表单
  public submitForm(): void {
    (this.$refs.permissionForm as ElForm).validate(async (isValid: boolean) => {
      if (!isValid) {
        this.$message.error('请检查并完善表单信息');
        return;
      }

      // 验证用户范围、用户组和用户邮箱至少填写一项
      const hasOpenRange = this.formData.openRange && this.formData.openRange.length > 0;
      const hasUserGroups = this.formData.userGroups && this.formData.userGroups.length > 0;
      const hasEmails = this.formData.emailsStr && this.formData.emailsStr.trim() !== '';
      
      if (!hasOpenRange && !hasUserGroups && !hasEmails) {
        this.$message.error('用户范围、用户组和用户邮箱必须至少填写一项');
        return;
      }

      // 如果有邮箱输入，需要先检测用户
      if (this.formData.emailsStr && this.formData.emailsStr.trim() !== '') {
        // 检查是否已经检测过用户
        if (!this.noNumshow) {
          this.$message.error('请先检测用户邮箱');
          return;
        }
        
        // 检查是否有无效用户
        if (this.noNum > 0) {
          this.$message.error(`存在 ${this.noNum} 个无效用户，请修正后再保存`);
          return;
        }
      }

      try {
        // 确认保存
        await this.$confirm('是否确认保存？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        });

        // 构建提交数据
        const submitData: any = {
          modelCode: this.formData.modelCode,
          appCovers: this.formData.appCovers.map((coverId: string) => {
            const cover = this.coverOptions.find((item: any) => item.id === coverId);
            return {
              id: coverId,
              name: cover ? cover.name : ''
            };
          }),
          openScope: this.formData.openRange,
          userGroups: this.formData.userGroups.map((groupId: string) => {
            const group = this.userGroupOptions.find((item: any) => item.id === groupId);
            return {
              groupId: groupId,
              groupType: group ? group.type : ''
            };
          }),
          emails: this.formatEmailString().split(',').map(email => email.trim()).filter(email => email)
        };

        if (this.isEdit) {
          submitData.id = this.formData.id;
          await this.nuoxiaoerService.updatePermission(submitData);
        } else {
          await this.nuoxiaoerService.addPermission(submitData);
        }

        this.$message({
          message: '保存成功',
          type: 'success'
        });

        this.emitSaved();
      } catch (error) {
        if (error === 'cancel') {
          return;
        }
        console.error('保存失败：', error);
        this.$message.error('保存失败：' + (error.message || '未知错误'));
      }
    });
  }

  // 取消按钮
  public async handleCancel(): Promise<void> {
    try {
      await this.$confirm('是否确认取消，一旦取消，当前信息将会丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '否',
        type: 'warning'
      });
      this.emitClose();
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }
}
